// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___Timestamps__timestamps-container___g83i5 {
  margin-top: 30px;
  font-size: 0.8em;
  color: #787878;
}
.src-styles-components-___Timestamps__timestamps-container___g83i5 div {
  padding: 3px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/Timestamps.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;AAJA;EAMI,gBAAA;AACJ","sourcesContent":[".timestamps-container {\n  margin-top: 30px;\n  font-size: 0.8em;\n  color: rgb(120, 120, 120);\n\n  div {\n    padding: 3px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `src-styles-components-___Timestamps__timestamps-container___g83i5`;
export { _1 as "timestamps-container" };
export default ___CSS_LOADER_EXPORT___;
